import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Wraps protected routes. While auth is loading shows a spinner; if the user
 * is unauthenticated redirects to /login. If `roles` is provided, the user's
 * role must be in the list.
 */
export default function ProtectedRoute({ children, roles = null }) {
  const { user } = useAuth();
  const loc = useLocation();

  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white">
        <Loader2 className="h-6 w-6 animate-spin text-accent-blue" />
      </div>
    );
  }
  if (user === null) {
    return <Navigate to="/login" state={{ from: `${loc.pathname}${loc.search}` }} replace />;
  }
  if (roles && roles.length && !roles.includes(user.role)) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white p-10 text-center">
        <div>
          <p className="eyebrow text-red-600">Acceso restringido</p>
          <h2 className="mt-2 font-display text-3xl text-ink">
            No tiene permisos para esta sección
          </h2>
          <p className="mt-3 text-sm text-slate-500">
            Su rol actual ({user.role}) no puede acceder. Solicite acceso al
            administrador.
          </p>
        </div>
      </div>
    );
  }
  return children;
}
